var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBug = function SvgBug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M64 40c0-8.837-7.163-16-16-16s-16 7.163-16 16v24c0 8.837 7.163 16 16 16s16-7.163 16-16zM76 28l-12 8M20 28l12 8M76 76l-12-8M20 76l12-8M80 52H64M16 52h16M40 16l4 8M56 16l-4 8"
  })));
};
export default SvgBug;